export const SELECTION_COLUMN_ID = '__row-selection'
